// ActionCell.js
import React, { useState } from "react";
import { IconButton, Tooltip, Box } from "@mui/material";
import PeopleIcon from "@mui/icons-material/People";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import DownloadIcon from "@mui/icons-material/Download";
import { useDispatch } from "react-redux";
import { getRecordingDownloadUrl } from "../../../../store/RecordedCalls/recordedCallsThunks";
import { useGridApiContext } from "@mui/x-data-grid-pro";
import { useTheme } from "@mui/material/styles";

const ActionCell = ({ id, row, onPlay, onShowParticipants }) => {
  const theme = useTheme();
  const dispatch = useDispatch();

  const handleShowParticipants = () => {
    onShowParticipants(id);
  };

  const handlePlay = () => {
    onPlay(row.id);
  };

  const handleDownload = async () => {
    const action = await dispatch(
      getRecordingDownloadUrl({ recordingId: row.id })
    );

    if (action.meta.requestStatus === "fulfilled") {
      const downloadUrl = action.payload;

      try {
        const response = await fetch(downloadUrl);
        const blob = await response.blob();
        const url = URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = `recording-${row.id}.mp3`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      } catch (err) {
        console.error("Download failed:", err);
      }
    } else {
      console.error("Download thunk failed:", action.payload);
    }
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
      <Tooltip title="Show Participants">
        <IconButton
          onClick={handleShowParticipants}
          size="small"
          sx={{
            mx: 0.5,
            color: theme.palette.text.primary,
            color: theme.palette.text.primary,
          }}
        >
          <PeopleIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title="Play">
        <IconButton
          onClick={handlePlay}
          size="small"
          sx={{ mx: 0.5, color: theme.palette.text.primary }}
        >
          <PlayArrowIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title="Download">
        <IconButton
          onClick={handleDownload}
          size="small"
          sx={{ mx: 0.5, color: theme.palette.text.primary }}
        >
          <DownloadIcon />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default ActionCell;
